module.exports = __webpack_public_path__ + "static/img/d6faceca1adad63e6f2d103272cb1df9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fw_zfsb.png
// module id = 14PY
// module chunks = 1